import { collections } from "@/mocks/comics";

export default function Collections() {
  return (
    <section id="collections" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-700">
              <i className="ri-stack-line"></i> 编辑精选
            </span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
              热门沙雕合集
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              一份份让人笑到缺氧的搞笑合集，覆盖沙雕日常、神吐槽、梗图段子，
              每一个都是编辑部精挑细选的快乐源泉。
            </p>
          </div>
          <a
            href="#categories"
            className="whitespace-nowrap text-sm text-primary-600 hover:text-primary-700"
          >
            查看全部分类 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {collections.map((c) => (
            <article
              key={c.id}
              className="group overflow-hidden rounded-2xl border border-background-200 bg-background-100/60 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[4/3] w-full overflow-hidden">
                <img
                  src={c.image}
                  alt={`韩国歪歪漫画-${c.title}`}
                  title={`${c.title}-沙雕搞笑合集`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex flex-wrap gap-1.5">
                  {c.tags.map((t) => (
                    <span
                      key={t}
                      className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
                    >
                      {t}
                    </span>
                  ))}
                </div>
                <h3 className="mt-3 font-heading text-base text-foreground-950 md:text-lg">
                  {c.title}
                </h3>
                <p className="mt-1.5 line-clamp-2 text-sm text-foreground-600">{c.desc}</p>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line"></i> {c.views}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-heart-3-fill text-accent-500"></i> {c.likes.toLocaleString()}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}